import template from './scores_menu.html'

export default {
  template,
  controller: 'scoresMenuController as scoresMenu'
}
